<template>
    <div class="container price-container">
        <cmp-price :form="schemeInfo"
                    @onSave="onSavePrice"></cmp-price>
    </div>
</template>

<script>
import Service from '@/api/Service'
import CmpPrice from '@/components/CmpChargeScheme/CmpPrice'
import { mapGetters } from "vuex";
export default {
    name: "priceset",
    data() {
        return {
            schemeId: '',
            schemeInfo: {},
        };
    },
    components: {
        CmpPrice
    },
	computed: {
	    // 项目子系统列表
	    ...mapGetters(["projectsystemInfo"])
	},
    created() {
        this.schemeId = this.$route.params.schemeId;
        this.getData(this.schemeId);
    },
    methods: {
        // 获取计费方案明细
        async getData(oid) {
            // let data = await Service.getChargeSchemeInfo({OID : oid});
			let data = await Service.getChargeSchemeList();
            if(data) {
                this.schemeInfo = data;
            }
        },
        // 保存价格设置
        async onSavePrice(params) {
			// console.log(params)
			// params.project_sys_id =this.projectsystemInfo.oid
            let data = await Service.editScheme_price(params);
            if(data) {
                this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                });
                this.$router.push('/setchargescheme')
            }
        },
    }
};
</script>

<style scoped>
.price-container {
    padding: 24px 32px;
    background: #fff;
}
.title {
    padding: 4px;
    margin-bottom: 12px;
    font-size: 18px;
    border-bottom: 1px solid #dcdfe6;
}
.price-setting-box {
    width: 600px;
    margin: auto;
}
.holiday-list-box {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    padding: 8px 12px;
}
</style>

